/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { Colors } from 'utils';

const SkilsIcon = ({ color, width, height }) => {
  return (
    <svg
      height={`${height || '29'}px`}
      width={`${width || '21'}px`}
      viewBox="0 0 21 29"
      css={css`
        fill: ${color || Colors.black};
        max-width: ${width || '21'}px;
        max-height: ${height || '29'}px;
        height: ${height || '29'}px;
        width: ${width || '21'}px;
      `}
    >
      <mask
        id="mask0"
        masktype="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="23"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0.423489H19.3614V22.1086H0V0.423489Z"
          fill={`${Colors.white}`}
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.36842 18.1426C4.85078 19.0829 4.78725 21.3157 4.7864 21.3356C4.77751 21.5377 4.85162 21.7342 4.99139 21.8803C5.13115 22.026 5.32428 22.1086 5.52673 22.1086H15.9998C16.3979 22.1086 16.7244 21.7943 16.7405 21.397C16.9387 16.4337 13.0588 13.1331 11.36 11.9312C12.3261 11.8304 14.6089 12.2488 16.7736 12.9701C16.8091 12.9819 16.8451 12.9908 16.882 12.9972C17.904 13.1734 18.4888 12.8074 18.7993 12.469C19.6735 11.5161 19.2893 9.83808 19.2033 9.51154C19.1788 9.41921 19.1364 9.33196 19.0792 9.25531C18.1708 8.04443 14.65 5.38636 13.8355 4.77902L13.3544 3.92349C13.2456 3.73036 13.0562 3.59611 12.8381 3.55714L11.011 3.23229L11.0038 0.423447L10.1568 0.548388C7.76678 0.900341 6.65925 2.3738 6.24631 3.11159C5.62202 3.2378 4.48019 3.61305 3.50395 4.70702L3.4328 4.65408C3.10499 4.41013 2.64038 4.47832 2.39558 4.80655C2.15162 5.13521 2.21981 5.5994 2.54805 5.84378L3.84024 6.80476C3.97322 6.90387 4.12823 6.95131 4.28198 6.95131C4.50814 6.95131 4.73176 6.84839 4.87746 6.65272C5.12184 6.32406 5.05322 5.85987 4.72499 5.61549L4.69958 5.59686C5.64193 4.61131 6.72405 4.53168 6.77148 4.52872L7.26574 4.50754L7.43558 4.04335C7.44108 4.02853 7.91882 2.77785 9.52612 2.21963L9.53035 3.86759C9.53162 4.27672 9.86282 4.60707 10.2715 4.60707H10.2736C10.2855 4.60707 10.2965 4.60411 10.3088 4.60368C10.3393 4.61342 10.3694 4.62443 10.402 4.62994L12.2342 4.95564L12.6208 5.64302C12.6721 5.73408 12.7416 5.81286 12.8254 5.87512C13.949 6.70778 16.9425 9.01135 17.8019 10.0308C17.9035 10.5289 17.9243 11.2315 17.7066 11.4674C17.6024 11.5813 17.3525 11.569 17.1848 11.5445C15.799 11.0862 11.4866 9.7898 10.0454 10.8808C9.65826 11.1735 9.45835 11.6089 9.48122 12.1065C9.49308 12.3585 9.63285 12.5876 9.85139 12.7138C9.90475 12.7452 14.9761 15.7408 15.2531 20.6262H6.23191C6.12306 19.6174 5.70631 17.8703 4.16254 16.8907C2.34221 15.737 1.8632 14.5668 2.14485 11.6715L2.16687 11.6779C2.2376 11.6991 2.30918 11.7092 2.37948 11.7092C2.6984 11.7092 2.99318 11.5017 3.08932 11.1802C3.20664 10.7881 2.98386 10.3751 2.59167 10.2578L0.953882 9.76778C0.562541 9.65088 0.148329 9.87323 0.0310116 10.2654C-0.0858825 10.6576 0.13647 11.0706 0.529082 11.1879L0.701035 11.2395C0.356706 14.4016 0.719671 16.4634 3.36842 18.1426Z"
          fill={`${color || Colors.black}`}
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.29958 8.47838L2.75398 9.16831C2.85647 9.21702 2.96489 9.23989 3.0712 9.23989C3.34861 9.23989 3.61459 9.0836 3.74122 8.81636C3.91699 8.44662 3.75943 8.00445 3.38927 7.82911L1.93487 7.13918C1.56513 6.96426 1.12339 7.12139 0.947623 7.49113C0.772282 7.86087 0.929835 8.30304 1.29958 8.47838Z"
        fill={`${color || Colors.black}`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7389 27.7622C19.6394 27.4408 18.7241 24.5976 17.2651 23.776C17.119 23.6938 16.9572 23.6688 16.8026 23.69C16.7695 23.6858 16.7365 23.6798 16.7022 23.6798H4.53717C4.52531 23.6798 4.5143 23.6828 4.50202 23.6836C4.36479 23.6752 4.22333 23.7035 4.09416 23.776C2.6351 24.5976 1.72028 27.4408 1.62075 27.7622L1.32385 28.7224H20.0362L19.7389 27.7622ZM3.3911 27.24C3.74559 26.3993 4.23223 25.5222 4.69091 25.1622H16.6687C17.1279 25.5222 17.6136 26.3993 17.9681 27.24H3.3911Z"
        fill={`${color || Colors.black}`}
      />
    </svg>
  );
};

export default SkilsIcon;

SkilsIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
